import {
  COMPANY_PROFILE_LOADING,
  COMPANY_PROFILE_FETCH,
  COMPANY_PROFILE_ERROR,
} from "../actions/constants";

const initialState = {
  profile: null,
  isLoading: false,
  error: null,
};

const companyProfile = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_PROFILE_LOADING:
      return { ...state, isLoading: true, error: null };
    case COMPANY_PROFILE_FETCH:
      return { ...state, profile: action.payload, isLoading: false, error: null };
    case COMPANY_PROFILE_ERROR:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default companyProfile;
